import React from 'react';
import HeaderButton from './ui/HeaderButton';
import { translate } from '../../Services/translation';
import { useSelector } from 'react-redux';

const Contact = () => {
  const { contactUsPageUrl } = useSelector((state) => state.site);

  return contactUsPageUrl ? (
    <HeaderButton
      icon="Headset"
      label={translate('general.contact')}
      hideOnMobile={true}
      renderAsLink={true}
      linkUrl={contactUsPageUrl}
    />
  ) : null;
};

export default Contact;
